import Vue from 'vue';
import KanbasuVue from 'kanbasu-vue';
import vClickOutside from 'v-click-outside';
import Notifications from 'vue-notification';
import VueGoogleMaps from 'vue-googlemaps';
import * as Sentry from '@sentry/browser';
import { Vue as SentryVue } from '@sentry/integrations';
import CompositionApi from '@vue/composition-api';
import Chusho from 'chusho';
import ChushoConfig from '../chusho.config.js';
import { setInteractionMode } from 'vee-validate';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './config/forms/rules';

/**
 * Setting up Chusho
 */

Vue.use(CompositionApi);
Vue.use(Chusho, ChushoConfig);

/**
 * Track errors in Sentry
 */

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new SentryVue({ Vue, attachProps: true })],
  });
}

/**
 * Configure VeeValidate
 */

setInteractionMode('eager');

/**
 * Define some components globally
 */

Vue.use(KanbasuVue);
Vue.use(vClickOutside);
Vue.use(Notifications);
if (process.env.VUE_APP_MAP_SUPPLIER?.toLowerCase() == 'google') {
  Vue.use(VueGoogleMaps, {
    load: {
      apiKey: `${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`,
    },
  });
}

import Icon from '@/components/ui/Icon';
import Form from '@/components/forms/Form';
import FormGroup from '@/components/forms/FormGroup';
import Input from '@/components/forms/fields/Input';
import Datepicker from '@/components/forms/fields/Datepicker';
Vue.component('Icon', Icon);
Vue.component('Form', Form);
Vue.component('FormGroup', FormGroup);
Vue.component('Input', Input);
Vue.component('Datepicker', Datepicker);

/**
 * Load global style
 */

import 'vue-googlemaps/dist/vue-googlemaps.css';
import './assets/scss/main.scss';

/**
 * Launch !
 */

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

if (window.Cypress) {
  window.__store__ = store;
}
